'use client';

import { useTranslations, useLocale } from 'next-intl';
import { HOTEL_PHONE_DISPLAY, HOTEL_PHONE_TEL, HOTEL_EMAIL } from '@/lib/contact';

export function PrivacyPolicyContent() {
  const t = useTranslations('legal');

  return (
    <div className="prose prose-sm max-w-none text-[#2c1810]/80">
      <h1 className="text-2xl font-serif text-[#801515] mb-6">{t('privacy.title')}</h1>

      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('privacy.section1.heading')}</h2>
      <p>{t('privacy.section1.intro')}</p>
      <p className="font-medium">
        {t('privacy.section1.companyName')}<br />
        {t('privacy.section1.companyAddress')}<br />
        {t('privacy.section1.companyCUI')}<br />
        {t('privacy.section1.phoneLabel')} <a href={`tel:${HOTEL_PHONE_TEL}`} className="text-[#801515] hover:underline">{HOTEL_PHONE_DISPLAY}</a><br />
        {t('privacy.section1.emailLabel')} <a href={`mailto:${HOTEL_EMAIL}`} className="text-[#801515] hover:underline">{HOTEL_EMAIL}</a>
      </p>
      <p>{t('privacy.section1.outro')}</p>

      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('privacy.section2.heading')}</h2>
      <p>{t('privacy.section2.intro')}</p>

      <h3 className="text-base font-semibold text-[#2c1810] mt-4 mb-2">{t('privacy.section2.reservation.heading')}</h3>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('privacy.section2.reservation.item1')}</li>
        <li>{t('privacy.section2.reservation.item2')}</li>
        <li>{t('privacy.section2.reservation.item3')}</li>
        <li>{t('privacy.section2.reservation.item4')}</li>
        <li>{t('privacy.section2.reservation.item5')}</li>
        <li>{t('privacy.section2.reservation.item6')}</li>
      </ul>

      <h3 className="text-base font-semibold text-[#2c1810] mt-4 mb-2">{t('privacy.section2.stay.heading')}</h3>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('privacy.section2.stay.item1')}</li>
        <li>{t('privacy.section2.stay.item2')}</li>
      </ul>

      <h3 className="text-base font-semibold text-[#2c1810] mt-4 mb-2">{t('privacy.section2.contact.heading')}</h3>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('privacy.section2.contact.item1')}</li>
      </ul>

      <h3 className="text-base font-semibold text-[#2c1810] mt-4 mb-2">{t('privacy.section2.website.heading')}</h3>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('privacy.section2.website.item1')}</li>
        <li>{t('privacy.section2.website.item2')}</li>
      </ul>

      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('privacy.section3.heading')}</h2>
      <p>{t('privacy.section3.intro')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('privacy.section3.item1')}</li>
        <li>{t('privacy.section3.item2')}</li>
        <li>{t('privacy.section3.item3')}</li>
        <li>{t('privacy.section3.item4')}</li>
        <li>{t('privacy.section3.item5')}</li>
        <li>{t('privacy.section3.item6')}</li>
      </ul>

      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('privacy.section4.heading')}</h2>
      <p>{t('privacy.section4.intro')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li><strong>{t('privacy.section4.contract')}</strong> {t('privacy.section4.contractDesc')}</li>
        <li><strong>{t('privacy.section4.legal')}</strong> {t('privacy.section4.legalDesc')}</li>
        <li><strong>{t('privacy.section4.legitimate')}</strong> {t('privacy.section4.legitimateDesc')}</li>
        <li><strong>{t('privacy.section4.consent')}</strong> {t('privacy.section4.consentDesc')}</li>
      </ul>

      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('privacy.section5.heading')}</h2>
      <p>{t('privacy.section5.para1')}</p>
      <p>{t('privacy.section5.para2')}</p>
      <p>{t('privacy.section5.para3')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('privacy.section5.item1')}</li>
        <li>{t('privacy.section5.item2')}</li>
      </ul>

      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('privacy.section6.heading')}</h2>
      <p>{t('privacy.section6.para1')}</p>
      <p>{t('privacy.section6.para2')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('privacy.section6.item1')}</li>
        <li>{t('privacy.section6.item2')}</li>
        <li>{t('privacy.section6.item3')}</li>
        <li>{t('privacy.section6.item4')}</li>
        <li>{t('privacy.section6.item5')}</li>
        <li>{t('privacy.section6.item6')}</li>
      </ul>

      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('privacy.section7.heading')}</h2>

      <h3 className="text-base font-semibold text-[#2c1810] mt-4 mb-2">{t('privacy.section7.mailchimp.heading')}</h3>
      <p>{t('privacy.section7.mailchimp.para1')}</p>
      <p>{t('privacy.section7.mailchimp.para2')}</p>

      <h3 className="text-base font-semibold text-[#2c1810] mt-4 mb-2">{t('privacy.section7.analytics.heading')}</h3>
      <p>{t('privacy.section7.analytics.para1')}</p>
      <p>{t('privacy.section7.analytics.para2')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('privacy.section7.analytics.item1')}</li>
        <li>{t('privacy.section7.analytics.item2')}</li>
        <li>{t('privacy.section7.analytics.item3')}</li>
      </ul>
      <p>{t('privacy.section7.analytics.para3')}</p>

      <h3 className="text-base font-semibold text-[#2c1810] mt-4 mb-2">{t('privacy.section7.advertising.heading')}</h3>
      <p>{t('privacy.section7.advertising.para1')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('privacy.section7.advertising.item1')}</li>
        <li>{t('privacy.section7.advertising.item2')}</li>
      </ul>
      <p>{t('privacy.section7.advertising.para2')}</p>
      <p className="text-sm italic mt-4">{t('privacy.section7.trackingNote')}</p>

      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('privacy.section8.heading')}</h2>
      <p>{t('privacy.section8.intro')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('privacy.section8.item1')}</li>
        <li>{t('privacy.section8.item2')}</li>
        <li>{t('privacy.section8.item3')}</li>
        <li>{t('privacy.section8.item4')}</li>
        <li>{t('privacy.section8.item5')}</li>
        <li>{t('privacy.section8.item6')}</li>
      </ul>
      <p>{t('privacy.section8.contact')} <a href={`mailto:${HOTEL_EMAIL}`} className="text-[#801515] hover:underline">{HOTEL_EMAIL}</a></p>

      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('privacy.section9.heading')}</h2>
      <p>{t('privacy.section9.intro')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('privacy.section9.item1')}</li>
        <li>{t('privacy.section9.item2')}</li>
        <li>{t('privacy.section9.item3')}</li>
      </ul>

      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('privacy.section10.heading')}</h2>
      <p>{t('privacy.section10.para1')}</p>
    </div>
  );
}

export function CookiesPolicyContent() {
  const t = useTranslations('legal');

  return (
    <div className="prose prose-sm max-w-none text-[#2c1810]/80">
      <h1 className="text-2xl font-serif text-[#801515] mb-6">{t('cookies.title')}</h1>

      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('cookies.section1.heading')}</h2>
      <p>{t('cookies.section1.para1')}</p>
      <p>{t('cookies.section1.para2')}</p>
      <p>{t('cookies.section1.para3')}</p>

      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('cookies.section2.heading')}</h2>
      <p>{t('cookies.section2.intro')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('cookies.section2.item1')}</li>
        <li>{t('cookies.section2.item2')}</li>
        <li>{t('cookies.section2.item3')}</li>
        <li>{t('cookies.section2.item4')}</li>
        <li>{t('cookies.section2.item5')}</li>
      </ul>

      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('cookies.section3.heading')}</h2>

      <h3 className="text-base font-semibold text-[#2c1810] mt-4 mb-2">{t('cookies.section3.essential.heading')}</h3>
      <p>{t('cookies.section3.essential.para1')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('cookies.section3.essential.item1')}</li>
        <li>{t('cookies.section3.essential.item2')}</li>
        <li>{t('cookies.section3.essential.item3')}</li>
      </ul>
      <p>{t('cookies.section3.essential.para2')}</p>

      <h3 className="text-base font-semibold text-[#2c1810] mt-4 mb-2">{t('cookies.section3.analytics.heading')}</h3>
      <p>{t('cookies.section3.analytics.para1')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li><strong>{t('cookies.section3.analytics.tool')}</strong></li>
      </ul>
      <p>{t('cookies.section3.analytics.para2')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('cookies.section3.analytics.item1')}</li>
        <li>{t('cookies.section3.analytics.item2')}</li>
        <li>{t('cookies.section3.analytics.item3')}</li>
      </ul>
      <p>{t('cookies.section3.analytics.para3')}</p>

      <h3 className="text-base font-semibold text-[#2c1810] mt-4 mb-2">{t('cookies.section3.marketing.heading')}</h3>
      <p>{t('cookies.section3.marketing.para1')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li><strong>{t('cookies.section3.marketing.tool')}</strong></li>
      </ul>
      <p>{t('cookies.section3.marketing.para2')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('cookies.section3.marketing.item1')}</li>
        <li>{t('cookies.section3.marketing.item2')}</li>
        <li>{t('cookies.section3.marketing.item3')}</li>
      </ul>

      <h3 className="text-base font-semibold text-[#2c1810] mt-4 mb-2">{t('cookies.section3.functionality.heading')}</h3>
      <p>{t('cookies.section3.functionality.para1')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('cookies.section3.functionality.item1')}</li>
        <li>{t('cookies.section3.functionality.item2')}</li>
      </ul>

      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('cookies.section4.heading')}</h2>
      <p>{t('cookies.section4.para1')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('cookies.section4.item1')}</li>
        <li>{t('cookies.section4.item2')}</li>
        <li>{t('cookies.section4.item3')}</li>
      </ul>
      <p>{t('cookies.section4.para2')}</p>

      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('cookies.section5.heading')}</h2>
      <p>{t('cookies.section5.para1')}</p>
      <p>{t('cookies.section5.para2')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('cookies.section5.item1')}</li>
        <li>{t('cookies.section5.item2')}</li>
        <li>{t('cookies.section5.item3')}</li>
      </ul>
      <p>{t('cookies.section5.para3')}</p>

      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('cookies.section6.heading')}</h2>
      <p>{t('cookies.section6.para1')}</p>
      <p>{t('cookies.section6.para2')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('cookies.section6.item1')}</li>
      </ul>
      <p>{t('cookies.section6.para3')} <a href="https://www.allaboutcookies.org" target="_blank" rel="noopener noreferrer" className="text-[#801515] hover:underline">www.allaboutcookies.org</a></p>

      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('cookies.section7.heading')}</h2>
      <p>{t('cookies.section7.para1')}</p>

      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('cookies.section8.heading')}</h2>
      <p>{t('cookies.section8.para1')}</p>
    </div>
  );
}

export function TermsContent() {
  const t = useTranslations('legal');
  const locale = useLocale();

  return (
    <div className="prose prose-sm max-w-none text-[#2c1810]/80">
      <h1 className="text-2xl font-serif text-[#801515] mb-6">{t('terms.title')}</h1>

      {/* Section 1 - Company Identification */}
      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('terms.section1.heading')}</h2>
      <p>{t('terms.section1.intro')}</p>
      <p className="font-medium">
        {t('terms.section1.companyName')}<br />
        {t('terms.section1.companyAddress')}<br />
        {t('terms.section1.companyReg')}<br />
        {t('terms.section1.companyCUI')}<br />
        {t('terms.section1.phoneLabel')} <a href={`tel:${HOTEL_PHONE_TEL}`} className="text-[#801515] hover:underline">{HOTEL_PHONE_DISPLAY}</a><br />
        {t('terms.section1.emailLabel')} <a href={`mailto:${HOTEL_EMAIL}`} className="text-[#801515] hover:underline">{HOTEL_EMAIL}</a>
      </p>
      <p>{t('terms.section1.classification')}</p>

      {/* Section 2 - Reservations */}
      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('terms.section2.heading')}</h2>
      <p>{t('terms.section2.intro')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('terms.section2.channel1')}</li>
        <li>{t('terms.section2.channel2')}</li>
        <li>{t('terms.section2.channel3')}</li>
      </ul>
      <p>{t('terms.section2.confirmed')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li><strong>{t('terms.section2.advance1')}</strong></li>
        <li><strong>{t('terms.section2.advance2')}</strong></li>
        <li>{t('terms.section2.advance3')}</li>
        <li>{t('terms.section2.advance4')}</li>
      </ul>
      <p>{t('terms.section2.agreement')}</p>

      <h3 className="text-base font-semibold text-[#2c1810] mt-4 mb-2">{t('terms.section2.thirdPartyHeading')}</h3>
      <p>{t('terms.section2.thirdPartyIntro')}</p>
      <p>{t('terms.section2.thirdPartyBestRates')}</p>
      <p>{t('terms.section2.thirdPartyItem1')}</p>
      <p>{t('terms.section2.thirdPartyItem2')}</p>
      <p>{t('terms.section2.thirdPartyItem3')}</p>
      <p>{t('terms.section2.thirdPartyItem4')}</p>
      <p>{t('terms.section2.thirdPartyItem5')}</p>

      {/* Section 3 - Rates & Payment */}
      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('terms.section3.heading')}</h2>
      <p>{t('terms.section3.intro')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('terms.section3.rate1')}</li>
        <li>{t('terms.section3.rate2')}</li>
        <li><strong>{t('terms.section3.rate3')}</strong></li>
      </ul>
      <p>{t('terms.section3.currency')}</p>
      <p>{t('terms.section3.minStay')}</p>

      <h3 className="text-base font-semibold text-[#2c1810] mt-4 mb-2">{t('terms.section3.ratePlansHeading')}</h3>

      <p className="font-medium">{t('terms.section3.plan1Heading')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('terms.section3.plan1Item1')}</li>
        <li>{t('terms.section3.plan1Item2')}</li>
        <li>{t('terms.section3.plan1Item3')}</li>
      </ul>

      <p className="font-medium">{t('terms.section3.plan2Heading')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('terms.section3.plan2Item1')}</li>
        <li>{t('terms.section3.plan2Item2')}</li>
        <li>{t('terms.section3.plan2Item3')}</li>
        <li>{t('terms.section3.plan2Item4')}</li>
        <li>{t('terms.section3.plan2Item5')}</li>
        <li className="italic">{t('terms.section3.plan2Item6intro')}</li>
        <li>
          {t('terms.section3.plan2Item6')}
          <ul className="list-[lower-alpha] pl-5 space-y-1 mt-2">
            <li>{t('terms.section3.plan2Item6a')}</li>
            <li>{t('terms.section3.plan2Item6b')}</li>
          </ul>
        </li>
        <li>{t('terms.section3.plan2Item7')}</li>
      </ul>

      <p className="font-medium">{t('terms.section3.plan3Heading')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('terms.section3.plan3Item1')}</li>
        <li>{t('terms.section3.plan3Item2')}</li>
        <li>{t('terms.section3.plan3Item3')}</li>
        <li>{t('terms.section3.plan3Item4')}</li>
        <li>{t('terms.section3.plan3Item5')}</li>
        <li>{t('terms.section3.plan3Item6')}</li>
        <li className="italic">{t('terms.section3.plan3Item7intro')}</li>
        <li>
          {t('terms.section3.plan3Item7')}
          <ul className="list-[lower-alpha] pl-5 space-y-1 mt-2">
            <li>{t('terms.section3.plan3Item7a')}</li>
            <li>{t('terms.section3.plan3Item7b')}</li>
          </ul>
        </li>
        <li>{t('terms.section3.plan3Item8')}</li>
      </ul>

      <h3 className="text-base font-semibold text-[#2c1810] mt-4 mb-2">{t('terms.section3.paymentHeading')}</h3>
      <p>{t('terms.section3.paymentIntro')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('terms.section3.payment1')}</li>
        <li>{t('terms.section3.payment2')}</li>
        <li>{t('terms.section3.payment3')}</li>
        <li>{t('terms.section3.payment4')}</li>
        <li>{t('terms.section3.payment5')}</li>
      </ul>
      <p>{t('terms.section3.paymentSecurityNote')}</p>

      {/* Section 4 - Cancellation */}
      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('terms.section4.heading')}</h2>

      <h3 className="text-base font-semibold text-[#2c1810] mt-4 mb-2">{t('terms.section4.generalHeading')}</h3>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('terms.section4.general1')}</li>
        <li>{t('terms.section4.general2')}</li>
      </ul>

      <h3 className="text-base font-semibold text-[#2c1810] mt-4 mb-2">{t('terms.section4.exceptionsHeading')}</h3>
      <p>{t('terms.section4.exception1')}</p>
      <p>{t('terms.section4.exception2')}</p>

      {/* Section 5 - Check-in & Check-out */}
      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('terms.section5.heading')}</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('terms.section5.checkin')}</li>
        <li>{t('terms.section5.checkout')}</li>
      </ul>
      <p>{t('terms.section5.earlyLate')}</p>
      <p className="font-medium">{t('terms.section5.lateCheckoutFee')}</p>

      {/* Section 6 - Use of Facilities */}
      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('terms.section6.heading')}</h2>

      <h3 className="text-base font-semibold text-[#2c1810] mt-4 mb-2">{t('terms.section6.restaurantHeading')}</h3>
      <p className="font-medium">{t('terms.section6.restaurantHoursHeading')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('terms.section6.breakfast')}</li>
        <li>{t('terms.section6.alaCarte')}</li>
        <li>{t('terms.section6.lastOrder')}</li>
      </ul>
      <p className="font-medium">{t('terms.section6.restaurantPoliciesHeading')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('terms.section6.restaurantPolicy1')}</li>
        <li>{t('terms.section6.restaurantPolicy2')}</li>
      </ul>

      <h3 className="text-base font-semibold text-[#2c1810] mt-4 mb-2">{t('terms.section6.spaHeading')}</h3>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('terms.section6.spa1')}</li>
        <li>{t('terms.section6.spa2')}</li>
        <li>{t('terms.section6.spa3')}</li>
        <li>{t('terms.section6.spa4')}</li>
      </ul>
      <p>{t('terms.section6.spaChildren')}</p>
      <p>{t('terms.section6.spaPrivate')}</p>

      {/* Section 7 - Children & Extra Guests */}
      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('terms.section7.heading')}</h2>
      <p>{t('terms.section7.intro')}</p>

      <p className="font-medium">{t('terms.section7.childrenHeading')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('terms.section7.children1')}</li>
      </ul>

      <p className="font-medium">{t('terms.section7.extraBedsHeading')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('terms.section7.extraBed1')}</li>
        <li>{t('terms.section7.extraBed2')}</li>
      </ul>
      <p>{t('terms.section7.maxOccupancy')}</p>

      {/* Section 8 - Pet Policy */}
      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('terms.section8.heading')}</h2>
      <p>{t('terms.section8.intro')}</p>
      <p>{t('terms.section8.allowed')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('terms.section8.room1')}</li>
        <li>{t('terms.section8.room4')}</li>
      </ul>
      <p className="font-medium">{t('terms.section8.fee')}</p>
      <p>{t('terms.section8.restriction')}</p>

      {/* Section 9 - House Rules */}
      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('terms.section9.heading')}</h2>

      <h3 className="text-base font-semibold text-[#2c1810] mt-4 mb-2">{t('terms.section9.smokingHeading')}</h3>
      <p>{t('terms.section9.smokingRule')}</p>
      <p className="font-medium">{t('terms.section9.smokingFee')}</p>

      <h3 className="text-base font-semibold text-[#2c1810] mt-4 mb-2">{t('terms.section9.quietHeading')}</h3>
      <p>{t('terms.section9.quietRule')}</p>

      <h3 className="text-base font-semibold text-[#2c1810] mt-4 mb-2">{t('terms.section9.conductHeading')}</h3>
      <p>{t('terms.section9.conductIntro')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('terms.section9.conduct1')}</li>
        <li>{t('terms.section9.conduct2')}</li>
        <li>{t('terms.section9.conduct3')}</li>
      </ul>
      <p>{t('terms.section9.conductLiability')}</p>

      {/* Section 10 - Vouchers & Promotions */}
      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('terms.section10.heading')}</h2>
      <p>{t('terms.section10.intro')}</p>
      <p>{t('terms.section10.detailsLink')}{' '}
        <a href={`https://danielcastle.ro/${locale}/gift-vouchers`} target="_blank" rel="noopener noreferrer" className="text-[#801515] hover:underline">https://danielcastle.ro/{locale}/gift-vouchers</a>
      </p>
      <p className="font-medium">{t('terms.section10.generalRulesHeading')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('terms.section10.rule1')}</li>
        <li>{t('terms.section10.rule2')}</li>
      </ul>

      {/* Section 11 - Force Majeure */}
      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('terms.section11.heading')}</h2>
      <p>{t('terms.section11.intro')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('terms.section11.item1')}</li>
        <li>{t('terms.section11.item2')}</li>
        <li>{t('terms.section11.item3')}</li>
      </ul>

      {/* Section 12 - Liability */}
      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('terms.section12.heading')}</h2>
      <p>{t('terms.section12.intro')}</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>{t('terms.section12.item1')}</li>
        <li>{t('terms.section12.item2')}</li>
      </ul>
      <p>{t('terms.section12.guestLiability')}</p>

      {/* Section 13 - GDPR */}
      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('terms.section13.heading')}</h2>
      <p>{t('terms.section13.para1')}</p>
      <p>{t('terms.section13.para2')}</p>

      {/* Section 14 - Governing Law */}
      <h2 className="text-lg font-semibold text-[#2c1810] mt-8 mb-3">{t('terms.section14.heading')}</h2>
      <p>{t('terms.section14.para1')}</p>
      <p>{t('terms.section14.para2')}</p>
    </div>
  );
}
